__webpack_require__.p = "/applications/najiz-data/";